import { isNil } from 'lodash-es';
import { err, ok } from '@whr/core_utils/result.js';
import { ConfigurationNotFoundError, ConfigurationNotFoundErrorCode } from '../error/configuration_not_found_in_storage.js';
import { ConfigurationNotSetError, ConfigurationNotSetErrorCode } from '../error/configuration_not_set_error.js';
export class StaticStorage {
    constructor(values) {
        this.values = values;
    }
    async get(key, _scope, _tenantId) {
        const value = this.values[key];
        if (isNil(value)) {
            return err(new ConfigurationNotFoundError(ConfigurationNotFoundErrorCode.CONFIGURATION_NOT_FOUND, `Configuration with key ${key} not found`));
        }
        return ok(value);
    }
    async set(_key, _scope, _value, _tenantId) {
        return err(new ConfigurationNotSetError(ConfigurationNotSetErrorCode.CONFIGURATION_CANNOT_BE_SET, 'Environment variables cannot be set'));
    }
}
//# sourceMappingURL=static_storage.js.map